import { useAuth } from "../context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children, adminOnly = false, superAdminOnly = false }) {
    const { user, loading } = useAuth();
    const loc = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-slate-500">Loading…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
    // Force a password change before doing anything else when a temp password is set.
    if (user.must_change && loc.pathname !== "/change-password") {
        return <Navigate to="/change-password" replace />;
    }
    if (superAdminOnly && user.role !== "super_admin") return <Navigate to="/" replace />;
    if (adminOnly && user.role !== "admin" && user.role !== "super_admin") return <Navigate to="/" replace />;
    return children;
}
